
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Modal,
  ModalBody,
  Input,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Label
} from "reactstrap";


import Header from "components/Headers/Header.js";
import { useFetch } from "hooks/useFetch";
import { Link } from "react-router-dom";

import { useState } from "react";
import { ModalTitle } from "react-bootstrap";
import { NotificationManager } from "react-notifications";


const Index = (props) => {
  const { data, isPending,fetchData } = useFetch(process.env.REACT_APP_NODE_SERVER_URL + '/api/courseBookingDetails');
  const [openModel, setOpenModel] = useState(false)
  const [course_id,setCourse_id] = useState(null)
  const [file, setFile] = useState(null)
  
  const handleModal = (id) => {
    setCourse_id(id)
    setOpenModel(true)
  }

  const fileUpload = async () => {
    const form = new FormData()
    form.append("course_id",course_id)
    form.append("file", file)
    try {
      const res = await fetch(`${process.env.REACT_APP_NODE_SERVER_URL}/api/uploadCourse`, {
            method: "post",
            body: form
      });
      
      if (res.status == 201) {
        setOpenModel(false)
        setFile(null)
        fetchData()
      } else {
        NotificationManager.error(res.error, '', 3000);
      }
    } catch (error) {
      console.log(error)
    }

  }
  const handleCampMom = async (id,course_id) => {
    const payload = {
      camp_mom: id,
      course_id
    }
     try {
       const res = await fetch(`${process.env.REACT_APP_NODE_SERVER_URL}/api/updateCampMom`, {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify(payload)
       });
      
      if (res.status == 201) {
        fetchData()
        NotificationManager.success("Updated", '', 3000);
      } else {
        NotificationManager.error("Something Went Wrong", '', 3000);
      }
    } catch (error) {
      console.log(error)
    }

  }
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="my-2" fluid>
        <Row className="mt-5">
        {isPending && <div className="text-center">
          <Spinner
          color="primary"
          style={{
            height: '3rem',
            width: '3rem'
          }}
          >
          </Spinner>
        </div>}
        {data && data.lenghth===0 &&<p>No course available!</p>}
          {data && data.map((each)=>(<Col key={each.course_id} className="mb-5 mb-xl-0 mt-5" xl="6">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">{each.course_name} 
                    </h3>
                    <h4>{new Date(each.course_from_date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                    {' '} to {' '}
                    {new Date(each.course_to_date).toLocaleDateString(undefined, { month: "short", day: "numeric",  year: "numeric" })}</h4>
                  </div>
                  <div className="col text-right d-flex justify-content-end gap-3">
                    <div style={{ cursor: "pointer" }} onClick={() => handleModal(each.course_id)}><i class="fas fa-cloud-upload-alt fa-lg" style={each.schedule_url != null ? {color:"#155724"} : {color:"#721c24"}}></i>&nbsp;</div>
                    {each.schedule_url != null && <div style={{ cursor: "pointer" }}><Link target="_blank" to={process.env.REACT_APP_NODE_SERVER_URL + each.schedule_url}><i className="fa fa-eye"></i></Link></div>}
                    <Link to={`/admin/course-detail/${each.course_id}`}>
                      <Button
                        color="primary"
                        size="sm"
                      >
                        View Details
                      </Button>
                    </Link>
                    
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                  <th scope="col">Level</th>
                    <th scope="col">Boys</th>
                    <th scope="col">Waitlist</th>
                    <th scope="col">Girls</th>
                    <th scope="col">Waitlist</th>
                  </tr>
                </thead>
                <tbody>
                  {each.levelSeats.map((each)=>(<tr key={each.id}>
                    <th scope="row">{each.level_name}</th>
                    <td>{each.boys_order_count} / {each.boys_seats}</td>
                    <td>{each.boys_waitlist_count}</td>
                    <td>{each.girls_order_count} / {each.girls_seats}</td>
                    <td>{each.girls_waitlist_count}</td>
                  </tr>))}
                </tbody>
              </Table>
              <FormGroup className="d-flex justify-content-end align-items-center m-0 p-2 gap-2" style={!each.camp_mom ? {background:"#f8d7da"} : {}}>
                <Label className="d-inline-block m-0 col-sm-6 text-right text-bold">Camp Mom</Label>
                <Input
                  type="select"
                  name="camp_mom"
                  className="col-sm-6"
                  onChange={(e) => handleCampMom(e.target.value,each.course_id)}
                  value={each.camp_mom}
                >
                  <option value={''}>Select</option>
                  <option value={1}>Manisha Date</option>
                  <option value={2}>Melissa Iyer</option>
                </Input>
              </FormGroup>
            </Card>
          </Col>))}
        </Row>
        <Modal
          isOpen={openModel}
          
        >
          <ModalHeader toggle={()=>setOpenModel(false)}>
            <ModalTitle>Upload Schedule</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <Input
              type="file"
              name="file"
              onChange={(e)=>setFile(e.target.files[0])}
            />
            
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={() => fileUpload()}>Upload</Button>
            <Button type="button" className="secondary" onClick={()=>setOpenModel(false)}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default Index;
